import api from '@/services/Api';
import Impfaktion from '@/types/Impfaktion';
import { successSwal } from '@/helper/swals';
import { ActionContext, Module } from 'vuex';
import { ImpfaktionenState, RootState } from '@/store/types';
import jspm from '@/services/PrintManager';

type Context = ActionContext<ImpfaktionenState, RootState>;

export const impfaktionen: Module<ImpfaktionenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            impfaktionen: false,
            printers: false,
        },
        impfaktionen: [],
        printers: [],
    },
    actions: {
        loadImpfaktionen({ commit, rootState }: Context): void {
            commit('setLoadersImpfaktionen', true);

            api.post('verwaltung/impfaktionen/load')
                .then((response) => commit('setImpfaktionen', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersImpfaktionen', false));
        },
        updateImpfaktion({ commit, dispatch }: Context, payload: Impfaktion): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/impfaktionen/speichern', payload)
                .then(() => {
                    successSwal('Impfaktion', 'gespeichert');
                    dispatch('loadImpfaktionen');
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteImpfaktion({ commit, dispatch }: Context, payload: Impfaktion): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/impfaktionen/loeschen', payload)
                .then(() => {
                    successSwal('Impfaktion', 'gelöscht');
                    dispatch('loadImpfaktionen');
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
        loadPrinters({ commit, dispatch }: Context): void {
            if (!jspm.printer?.hasConnected()) {
                dispatch('globals/setDialogDruckhinweis', true, { root: true });
                return;
            }

            const { JSPrintManager, WSStatus } = jspm.printer?.manager;

            if (JSPrintManager.websocket_status !== WSStatus.Open) {
                dispatch('globals/setDialogDruckhinweis', true, { root: true });
                return;
            }

            JSPrintManager
                .getPrinters()
                .then((printers: string[]) => commit('setPrinters', printers))
                .catch(console.error);
        },
    },
    mutations: {
        setImpfaktionen(state: ImpfaktionenState, payload: Impfaktion[]): void {
            state.impfaktionen = payload.map((data: Impfaktion) => new Impfaktion(data));
        },
        setDialogsDetail(state: ImpfaktionenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: ImpfaktionenState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: ImpfaktionenState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersImpfaktionen(state: ImpfaktionenState, loading: boolean): void {
            state.loaders.impfaktionen = loading;
        },
        setLoadersPrinters(state: ImpfaktionenState, loading: boolean): void {
            state.loaders.printers = loading;
        },
        setPrinters(state: ImpfaktionenState, printers: string[]): void {
            state.printers = printers;
        },
    },
};
